var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('form-fields-adicionar-usuario',{on:{"save":_vm.save,"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }